export default __webpack_public_path__ + "static/media/happyfeet.d0171479.png";